import { request } from "../httpClient";

function getUrl(prefixKey) {
  const prefix = (window.appConfig && window.appConfig[prefixKey]);
  return process.env.REACT_APP_API_URL + prefix;
}

export async function fetchGridConsumptionBySiteId({ queryKey }) {
  const [, siteId, start_date, end_date, timeout] = queryKey;
  const url = `${getUrl("getGridConsumptionUrl")}${siteId}` +
    `?start_date=${encodeURIComponent(start_date)}&end_date=${encodeURIComponent(end_date)}`;
  return request(url, {}, timeout);
}